import {
    cleanAreaGraphWidgetForDatabaseSync,
    cleanComboChartWidgetForDatabaseSync,
    cleanDonutChartWidgetForDatabaseSync,
    cleanHorizontalBarGraphWidgetForDatabaseSync,
    cleanLineGraphWidgetForDatabaseSync,
    cleanMultiBarGraphWidgetForDatabaseSync,
    cleanNumberTileWidgetForDatabaseSync,
    cleanPieChartWidgetForDatabaseSync,
    cleanStackedBarGraphWidgetForDatabaseSync,
    cleanTableWidgetForDatabaseSync,
    cleanTextWidgetForDatabaseSync,
    genericCleanWidgetForDatabaseSync,
} from "~/components/reports/widgetSpecific/cleanWidgetsForDatabaseSync";
import type {Widget} from "~/components/reports/widgetSpecific/widgets";
import {WidgetType} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/reportsWorkspaceCapability/domain/ReportJson";
import type {EnumDictionary} from "~/typeDefinitions";
import type {StoredWidget} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/reportsWorkspaceCapability/domain/ReportJson";

export const widgetTypeToCleanWidgetForDatabaseSync: EnumDictionary<StoredWidget["type"], (widget: Widget) => Partial<Widget>> = {
    [WidgetType.multiBarGraph]: cleanMultiBarGraphWidgetForDatabaseSync,
    [WidgetType.stackedBarGraph]: cleanStackedBarGraphWidgetForDatabaseSync,
    [WidgetType.horizontalBarGraph]: cleanHorizontalBarGraphWidgetForDatabaseSync,
    [WidgetType.lineGraph]: cleanLineGraphWidgetForDatabaseSync,
    [WidgetType.areaGraph]: cleanAreaGraphWidgetForDatabaseSync,
    [WidgetType.comboChart]: cleanComboChartWidgetForDatabaseSync,
    [WidgetType.pieChart]: cleanPieChartWidgetForDatabaseSync,
    [WidgetType.donutChart]: cleanDonutChartWidgetForDatabaseSync,
    [WidgetType.table]: cleanTableWidgetForDatabaseSync,
    [WidgetType.numberTile]: cleanNumberTileWidgetForDatabaseSync,
    [WidgetType.text]: cleanTextWidgetForDatabaseSync,
    [WidgetType.gauge]: genericCleanWidgetForDatabaseSync,
    [WidgetType.image]: genericCleanWidgetForDatabaseSync,
    [WidgetType.progressBar]: genericCleanWidgetForDatabaseSync,
};
